import React from "react";
var __jsx = React.createElement;
import stl from "./TechnicalError.module.css";
import { useTranslation } from "@i18n";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
var TechnicalError = function TechnicalError(_ref) {
  var text = _ref.text;
  var _useTranslation = useTranslation(["web_sell_trade"]),
    t = _useTranslation.t;
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("strong", null, text), /*#__PURE__*/React.createElement("p", null, t("try_again", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "whtBtn"].join(" "),
    onClick: function onClick() {
      webview.closeScreen()["catch"](function () {
        if (isWebView) return document.location.href = "app://close";
        document.location.href = createUrl("/");
      });
    }
  }, t("go_homepage", {
    ns: "web_Schedule"
  }))));
};
export default TechnicalError;